import fetch from "./sessionFetch";
import { authHeaders, baseUrl, handleResponse } from "./apiUtils";

// Only the current portal scope may expire a session. A late response from
// another account must not remove the token installed by a context switch.
async function handlePortalResponse(response) {
  if (response.status === 401) {
    const error = new Error("Unauthorized");
    error.code = 401;
    throw error;
  }
  if (response.status === 409) {
    let body = {};
    try { body = await response.json(); } catch (error) { /* Use the readable fallback for non-JSON responses. */ }
    const conflict = new Error(body.error || body.message || "Stan lekcji uległ zmianie. Sprawdź aktualne dane i spróbuj ponownie.");
    conflict.code = 409;
    throw conflict;
  }
  if (response.status >= 500) {
    throw new Error("Nie udało się zapisać zmiany. Odśwież dane i spróbuj ponownie.");
  }
  return handleResponse(response);
}

async function getClientPortal() {
  const response = await fetch(`${baseUrl}self-service/client-portal`, {
    headers: authHeaders(),
  });
  return handlePortalResponse(response);
}

async function cancelLessonParticipation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/cancel`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handlePortalResponse(response);
}

async function undoLessonCancellation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/undo-cancellation`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handlePortalResponse(response);
}

export default {
  getClientPortal,
  cancelLessonParticipation,
  undoLessonCancellation,
};
